<script>
	import Slideshow from "./Slideshow/Slideshow.svelte";
</script>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 1000px;
		margin: 0 auto;
	}

	.note {
		padding: 0px 100px;
	}
</style>

<main>
	<div class="shrink">
		<h1>Before and After</h1>
		<hr><br>
		<p class="note">Everyone wants to have a beautiful smile. If there is something about your smile that you would like to enhance, you have many choices. Porcelain veneers, all-porcelain crowns and or simple orthodontics are all options to give you the smile you desire!</p>
		<p class="note">Any dentist can make your teeth look solid, white and square. The true artistry of cosmetic dentistry is making the teeth look natural and compliment your smile. We go to great lengths to make your new smile look as natural and healthy as possible.</p>
	</div>
	<Slideshow />
</main>
